import RestClient from '@/api/api';

class DashboardAPI extends RestClient {
  async getStats() {
    return await this._get('/dashboard/stats');
  }
}

export default new DashboardAPI();
